export default __webpack_public_path__ + "static/media/SharpGroteskSmBold19.de21201a.woff";